/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'expand': {
    width: 16,
    height: 16,
    viewBox: '0 0 200 200',
    data: '<path pid="0" d="M178 130.5H78.3c-4.8 0-8.8-4.2-8.8-9.4s3.9-9.4 8.8-9.4H178c4.8 0 8.8 4.2 8.8 9.4-.1 5.2-4 9.4-8.8 9.4zM178 86.7H78.3c-4.8 0-8.8-4.2-8.8-9.4s3.9-9.4 8.8-9.4H178c4.8 0 8.8 4.2 8.8 9.4s-4 9.4-8.8 9.4zM177.3 44.5H24.7c-5.2 0-9.7-3.9-9.8-9.1-.2-5.3 4.1-9.7 9.4-9.7H177c5.2 0 9.7 3.9 9.8 9.1.1 5.4-4.1 9.7-9.5 9.7zM58.4 68.2v62.2L14.8 99.3l43.6-31.1c0-.1 0-.1 0 0zM24.2 153.9h152.7c5.2 0 9.7 3.9 9.8 9.1.2 5.3-4.1 9.7-9.4 9.7H24.7c-5.2 0-9.7-3.9-9.8-9.1-.2-5.3 4-9.7 9.3-9.7z"/>'
  }
})
